export const dropdownData = {
  typeofTransferOptions: [
    { key: "wallet", text: "De Wallet Bancamiga a Paytech", value: "wallet" },
    /*     {
      key: "third-bancamiga",
      text: "De Wallet Bancamiga a terceros Bancamiga",
      value: "third-bancamiga",
    }, */
    {
      key: "third-other",
      text: "De Wallet BDV a terceros",
      value: "third-other",
    },
  ],
  typeofDocOptions: [
    { key: "V", text: "V.", value: "V" },
    { key: "E", text: "E.", value: "E" },
    { key: "J", text: "J.", value: "J" },
    { key: "G", text: "G.", value: "G" },
  ],
};
